/**
 * 分类占比组件（百分比）
 * zxw
 * 创建时间：2025-12-09
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../../incs/Config.js';
import { isMobileDevice } from '../../../incs/FunHelper.js';

const ChartPiePercent = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart.coordinate({ type: 'theta', outerRadius: 0.8 });
        chart
            .interval()
            .transform({ type: 'stackY' })
            .encode('y', 'percent')
            .encode('color', 'type')
            .legend('color', { position: 'top', layout: { justifyContent: 'left' } })
            // .animate('enter', {
            //     type: 'waveIn',
            //     duration: 1000,
            // })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .label({
                position: 'spider',
                text: (data) => `${data.type}: ${data.percent}%`,
            })
            .tooltip((data) => ({
                name: data.type,
                value: `${data.percent}%`,
            }));
        chart.render();

        return () => {
            chart.destroy();
        }
    }, []);

    return <div id={chartId}></div>
}

export default ChartPiePercent;